import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Autocomplete, Backdrop, CircularProgress, Snackbar, TextField } from "@mui/material";
import "../../../../styles/AppCss.css";
import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDetalleGiftCard, getFiltrarUsuarios, postReasingarGiftCard } from "../../../../api/ApiService";

function GiftCardDetallePage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [dataGiftCard, setDataGiftCard] = useState(null);

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [loadingUsuarios, setLoadingUsuarios] = useState(false);
    const [nameCedula, setNameCedula] = useState("");
    const [usuarioSelected, setUsuarioSelected] = useState(null);

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const params = useParams();
    const { id } = params;
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");

    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleDetalleGiftCard = () => {
        getDetalleGiftCard(stateToken?.access_token, id)
            .then((response) => {
                setDataGiftCard(response || null);
            })
            .catch(() => {
                openAlert("error", "Error al cargar los datos del gift card.");
            })
            .finally(() => {
                setCargando(true);
            });
    };

    const handleApiReasignarGiftCard = () => {
        if (!usuarioSelected?.id) {
            openAlert("warning", "Debes seleccionar un usuario para reasignar.");
            return;
        }

        const body = {
            giftcard_id: id,
            usuario_id: usuarioSelected.id,
        };
        console.log("Reasignar GiftCard - Body:", body);

        setLoadingGuardar(true);

        postReasingarGiftCard(stateToken?.access_token, body)
            .then(() => {
                openAlert("success", "GiftCard reasignada con exito.");
                setUsuarioSelected(null);
                setNameCedula("");
                setDataUsuarios([]);
                handleDetalleGiftCard();
            })
            .catch(() => {
                openAlert("error", "Error al reasignar la GiftCard.");
            })
            .finally(() => {
                setLoadingGuardar(false);
            });
    };

    const handleApiFiltrarUsuarios = () => {
        const body = {
            page: "",
            per_page: "",
            estado: "",
            term: nameCedula,
            email: "",
            verificacion: "",
            tipo: "",
            tester: "",
        };

        setLoadingUsuarios(true);

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then((response) => {
                console.log("getFiltrarUsuarios response:", response);
                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                } else {
                    setDataUsuarios([]);
                }
            })
            .catch((error) => {
                console.log("error==>getFiltrarUsuarios", error);
                setDataUsuarios([]);
            })
            .finally(() => {
                setLoadingUsuarios(false);
            });
    };

    const getUsuarioLabel = (option) => {
        if (!option) return "";
        if (option.value) return option.value;
        const ci = option.ci || option.cedula || option.documento || "";
        const nombre = `${option.user?.first_name || option.first_name || option.name || ""} ${option.user?.last_name || option.last_name || ""}`.trim();
        return [nombre, ci].filter(Boolean).join(" - ");
    };

    useEffect(() => {
        if (id && stateToken) {
            handleDetalleGiftCard();
        }
    }, [id, stateToken]);

    useEffect(() => {
        if (!stateToken || mode === "view") return;

        const timeoutId = setTimeout(() => {
            if (nameCedula.trim().length >= 2) {
                handleApiFiltrarUsuarios();
            } else {
                setDataUsuarios([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [nameCedula, stateToken, mode]);

    const handleClose = () => {
        setOpen(false);
    };

    const giftcard = dataGiftCard?.giftcard || {};
    const resumen = dataGiftCard?.resumen || {};
    const localesUso = dataGiftCard?.locales_uso || [];
    const historialCanjes = dataGiftCard?.historial_canjes || [];

    const InfoRow = ({ label, value, noBorder = false }) => (
        <div className={`grid grid-cols-1 gap-2 py-2 sm:grid-cols-2 ${noBorder ? "" : "border-b border-gray-100"}`}>
            <p className="text-sm font-bold text-gray-800">{label}:</p>
            <p className="text-sm text-gray-700">{value || "-"}</p>
        </div>
    );

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    {cargando ? (
                        <div className="space-y-6">
                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h1 className="mb-4 text-2xl font-bold text-gray-800">Detalle GiftCard</h1>

                                <div className="space-y-0">
                                    <InfoRow label="Codigo" value={giftcard?.codigo_giftcard} />
                                    <InfoRow label="Comprador" value={giftcard?.comprador_descripcion} />
                                    <InfoRow label="Beneficiado" value={giftcard?.beneficiado_descripcion} />
                                    <InfoRow label="Tipo" value={giftcard?.tipo_giftcard} />
                                    <InfoRow label="Estado de uso" value={giftcard?.estado_uso} />
                                    <InfoRow label="Monto pagado" value={giftcard?.valor_compra_format} />
                                    <InfoRow label="Monto utilizado" value={giftcard?.valor_utilizado_format} />
                                    <InfoRow label="Saldo" value={giftcard?.saldo_format} />
                                    <InfoRow label="Fecha compra" value={giftcard?.fecha_compra_format} />
                                    <InfoRow label="Fecha asignacion" value={giftcard?.fecha_asignacion_format} />
                                    <InfoRow label="Nro Ticket" value={giftcard?.ticket_number} />
                                    <InfoRow
                                        label="Recibo"
                                        value={giftcard?.path_recibo || "-"}
                                        noBorder
                                    />
                                </div>
                            </div>

                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h2 className="mb-3 text-lg font-bold text-gray-800">Resumen</h2>
                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Cantidad canjes</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{resumen?.cantidad_canjes ?? 0}</p>
                                    </div>
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Total canjeado</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{resumen?.total_canjeado_format || "Gs. 0"}</p>
                                    </div>
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Saldo actual</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{resumen?.saldo_actual_format || "Gs. 0"}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h2 className="mb-3 text-lg font-bold text-gray-800">Locales de uso</h2>
                                {localesUso.length === 0 ? (
                                    <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-500">
                                        No hay locales de uso.
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="border-b border-gray-200 bg-gray-50">
                                                <tr>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Local</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">RUC</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Canjes</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Total canjeado</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {localesUso.map((item) => (
                                                    <tr key={item.local_id}>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.nombre_fantasia || "-"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.ruc || "-"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.cantidad_canjes || "0"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.total_canjeado_local_format || "Gs. 0"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h2 className="mb-3 text-lg font-bold text-gray-800">Historial de canjes</h2>
                                {historialCanjes.length === 0 ? (
                                    <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-500">
                                        No hay canjes registrados.
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="border-b border-gray-200 bg-gray-50">
                                                <tr>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Fecha canje</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Local</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Usuario</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Monto</th>
                                                    <th className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">Fecha pago</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {historialCanjes.map((item) => (
                                                    <tr key={item.gift_card_compra_canje_id}>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.fecha_canje_format || "-"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.nombre_fantasia || "-"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.usuario_canje_descripcion || "-"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.monto_canjeado_format || "Gs. 0"}</td>
                                                        <td className="px-3 py-2 text-sm text-gray-700">{item?.fecha_pago_format || "Pendiente"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* //tambien validar que //giftcard?.estado_uso !== "Usado" y que no este en mode view para mostrar el boton de reasignar */}
                            {giftcard?.estado_uso !== "Usado" && mode !== "view" && (
                                <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                    <h2 className="mb-3 text-lg font-bold text-gray-800">Reasignar GiftCard</h2>
                                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                        <div>
                                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Buscar usuario (cedula o nombre)</label>
                                            <Autocomplete
                                                disablePortal
                                                options={dataUsuarios}
                                                value={usuarioSelected}
                                                onChange={(event, value) => setUsuarioSelected(value)}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === "input") {
                                                        setNameCedula(newInputValue);
                                                    }
                                                }}
                                                getOptionLabel={getUsuarioLabel}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                loading={loadingUsuarios}
                                                loadingText="Cargando..."
                                                noOptionsText="No hay usuarios"
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option?.id}>
                                                        <div className="flex flex-col">
                                                            <span className="text-sm text-gray-800 font-medium">
                                                                {`${option.user?.first_name || option.first_name || ""} ${option.user?.last_name || option.last_name || ""}`.trim() || "Sin nombre"}
                                                            </span>
                                                            <span className="text-xs text-gray-500">
                                                                CI: {option.ci || option.cedula || option.documento || "-"}
                                                            </span>
                                                        </div>
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        label="Seleccione usuario"
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                backgroundColor: "#f1f5f9",
                                                                borderRadius: "0.5rem",
                                                                fontSize: "0.875rem",
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div className="flex items-end">
                                            <button
                                                type="button"
                                                onClick={handleApiReasignarGiftCard}
                                                className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                                            >
                                                Reasignar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="mb-6 h-6 w-1/3 animate-pulse rounded bg-gray-200" />
                            <div className="space-y-4">
                                <div className="h-10 animate-pulse rounded bg-gray-200" />
                                <div className="h-10 animate-pulse rounded bg-gray-200" />
                                <div className="h-24 animate-pulse rounded bg-gray-200" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled">
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default GiftCardDetallePage;
